import { useEffect } from "react";
import { WorkbooksCard } from "./card";
import { WorkbooksNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { WorkbooksTable } from "./table";

export default function Workbooks() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Cahiers de travail");
  }, []);

  return (
    <Routes>
      <Route index element={<WorkbooksTable />} />
      <Route path="/new" element={<WorkbooksNew />} />
      <Route path=":id" element={<WorkbooksCard />} />
    </Routes>
  );
}
